
import { Component, EventEmitter, Input, Output, OnDestroy, ViewChild, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TipologiaContenidoFormulario } from '../domain/TipologiaContenidoFormulario';
import { AppComponent } from '../app.component';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import { Contenido, ContenidoIdiomaFormulario } from '../domain/Contenido';
import {
	Predicate
} from 'breeze-client';
import { Idioma } from '../domain/Idioma';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';

@Component({
	selector: 'app-formulario-QR',
	templateUrl: './FormularioQR.component.html'
})


export class FormularioQR implements OnDestroy, OnChanges, OnInit { //  extends FormGroup { // extends FormularioBaseComponent<ALA> {
    @Input() contenidosSeleccionados: Contenido = new Contenido();
	constructor(
    private appComponent: AppComponent,
	private entityManager: EntityManagerProvider,
	public authService: AuthenticationService,
	public sws: ServiciosWebServiceProvider)
	{

	}

	ngOnInit(){
		
	}

	ngOnChanges(changes: SimpleChanges): void {

	
	
	}
    
	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioQR.component.ts